// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { ItemsPublishingQueries } from '../../../../types/server/modules/itemsPublishing/queries';

export type * from '../../../../types/server/modules/itemsPublishing/queries';

export const createQueries = ( requests: Requests ): ItemsPublishingQueries => ({
  ItemsPublishingInventorySpreadsheet: ( params?, headers? ) => {
        return requests.get( `/items-publishing/inventory-spreadsheet`, params, headers );
      },
  ItemsPublishingInventoryDistinctCategories: ( params?, headers? ) => {
        return requests.get( `/items-publishing/inventory-distinct-categories`, params, headers );
      },
  ItemsPublishingInventorySearch: ( params?, headers? ) => {
        return requests.get( `/items-publishing/inventory-search/:search?`, params, headers );
      },
  ItemsPublishingOrderItemsSearch: ( params?, headers? ) => {
        return requests.get( `/items-publishing/order-items-search/:search?`, params, headers );
      },
  ItemsPublishingInventoryStockBreak: ( params?, headers? ) => {
        return requests.get( `/items-publishing/inventory-stock-break/:threshold?`, params, headers );
      },
  ItemsPublishingInventoryDuplicateDiff: ( params?, headers? ) => {
        return requests.get( `/items-publishing/inventory/duplicate-diff/:sourceId/:targetId`, params, headers );
      },
  ItemsPublishingInventoryById: ( id, query, headers ) => { 
          return requests.get( `/items-publishing/inventory/${id}`, query, headers ); 
        },
  ItemsPublishingInventory: ( params?, headers? ) => {
        return requests.get( `/items-publishing/inventory/:id?`, params, headers );
      },
  ItemsPublishingPublicationsDistinctCategories: ( params?, headers? ) => {
        return requests.get( `/items-publishing/publications-distinct-categories`, params, headers );
      },
  ItemsPublishingPublicationsSearch: ( params?, headers? ) => {
        return requests.get( `/items-publishing/publications-search/:search?`, params, headers );
      },
  ItemsPublishingPublicationsIds: ( params?, headers? ) => {
        return requests.get( `/items-publishing/publicationsIds`, params, headers );
      },
  ItemsPublishingPublicationsCount: ( params?, headers? ) => {
        return requests.get( `/items-publishing/publications-count/`, params, headers );
      },
  ItemsPublishingPublicationsById: ( id, query, headers ) => { 
          return requests.get( `/items-publishing/publications/${id}`, query, headers ); 
        },
  ItemsPublishingPublications: ( params?, headers? ) => {
        return requests.get( `/items-publishing/publications/:id?`, params, headers );
      },
  ItemsPublishingPublicationsRetailCodes: ( params?, headers? ) => {
        return requests.get( `/items-publishing/publications-retail-codes`, params, headers );
      },
  ItemsPublishingPublicationsBulkEditResults: ( params?, headers? ) => {
        return requests.get( `/items-publishing/publications-bulk-edit-results/:batchProcessId?`, params, headers );
      },
  ItemsPublishingPublicationDriftEpisodesSearch: ( params?, headers? ) => {
        return requests.get( `/items-publishing/publication-drift-episodes-search/:search?`, params, headers );
      },
  ItemsPublishingPublicationDriftEpisodesById: ( id, query, headers ) => { 
          return requests.get( `/items-publishing/publication-drift-episodes/${id}`, query, headers ); 
        },
  ItemsPublishingPublicationDriftEpisodes: ( params?, headers? ) => {
        return requests.get( `/items-publishing/publication-drift-episodes/:id?`, params, headers );
      },
  ItemsPublishingChannelsCommisions: ( params?, headers? ) => {
        return requests.get( `/items-publishing/channels-commisions`, params, headers );
      },
  ItemsPublishingPriceListsById: ( id, query, headers ) => { 
          return requests.get( `/items-publishing/price-lists/${id}`, query, headers ); 
        },
  ItemsPublishingPriceLists: ( params?, headers? ) => {
        return requests.get( `/items-publishing/price-lists/:id?`, params, headers );
      },
  ItemsPublishingSizeGuidesById: ( id, query, headers ) => { 
          return requests.get( `/items-publishing/size-guides/${id}`, query, headers ); 
        },
  ItemsPublishingSizeGuides: ( params?, headers? ) => {
        return requests.get( `/items-publishing/size-guides/:id?`, params, headers );
      },
  ItemsPublishingSizeGuidesSearch: ( params?, headers? ) => {
        return requests.get( `/items-publishing/size-guides-search/:search?`, params, headers );
      },
  GoogleProductsCategoriesReadmodelById: ( id, query, headers ) => { 
          return requests.get( `/google-products-categories-readmodel/${id}`, query, headers ); 
        },
  GoogleProductsCategoriesReadmodel: ( params?, headers? ) => {
        return requests.get( `/google-products-categories-readmodel/:id?`, params, headers );
      },
  ItemPublishingMercadolibreCategoriesSearch: ( params?, headers? ) => {
        return requests.get( `/item-publishing/mercadolibre-categories/search`, params, headers );
      },
  ItemPublishingMercadolibreCategoriesById: ( id, query, headers ) => { 
          return requests.get( `/item-publishing/mercadolibre-categories/${id}`, query, headers ); 
        },
  ItemPublishingMercadolibreCategories: ( params?, headers? ) => {
        return requests.get( `/item-publishing/mercadolibre-categories/:id?`, params, headers );
      },
  ItemsPublishingAccountConfigurationReadmodelById: ( id, query, headers ) => { 
          return requests.get( `/items-publishing/account-configuration-readmodel/${id}`, query, headers ); 
        },
  ItemsPublishingAccountConfigurationReadmodel: ( params?, headers? ) => {
        return requests.get( `/items-publishing/account-configuration-readmodel/:id?`, params, headers );
      },
  ItemsPublishingUserPreferencesReadmodelById: ( id, query, headers ) => { 
          return requests.get( `/items-publishing/user-preferences-readmodel/${id}`, query, headers ); 
        },
  ItemsPublishingUserPreferencesReadmodel: ( params?, headers? ) => {
        return requests.get( `/items-publishing/user-preferences-readmodel/:id?`, params, headers );
      },
  FenicioPublicationsReadmodelById: ( id, query, headers ) => { 
          return requests.get( `/fenicio-publications-readmodel/${id}`, query, headers ); 
        },
  FenicioPublicationsReadmodel: ( params?, headers? ) => {
        return requests.get( `/fenicio-publications-readmodel/:id?`, params, headers );
      }
});
